module.exports = __webpack_public_path__ + "static/media/individual.9adeb82b.jpg";